
const ConfirmUpdatePopUpLensCreation = ({ onClose, heading, subHeading, powers, update }) => {


    return (
        <div className="BillBar-modal" style={{ zIndex: 10 }}>
            <div className="BillBar-modal-content relative">
                <div className="BillBar-modal-header" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <h2>{heading}</h2>
                    {/* <button style={{position:"absolute", top}}>Back to Report</button> */}

                    <div className="BillBar-modal-relative-buttons">

                        <button onClick={onClose} className="BillBar-modal-close">
                            ✖
                        </button>

                    </div>

                </div>
                <p className="mt-2">{subHeading || ""}</p>

                <div className="confirm-update-popup-lens-creation-grid-container">

                    <div className="confirm-update-popup-lens-creation-grid-container-div">SPH Min: {powers.SPH_Min}</div>
                    <div className="confirm-update-popup-lens-creation-grid-container-div">SPH Max: {powers.SPH_Max}</div>
                    <div className="confirm-update-popup-lens-creation-grid-container-div">SPH Step: {powers.SPH_Step}</div>
                    <div className="confirm-update-popup-lens-creation-grid-container-div">CYL Min: {powers.CYL_Min}</div>
                    <div className="confirm-update-popup-lens-creation-grid-container-div">CYL Max: {powers.CYL_Max}</div>
                    <div className="confirm-update-popup-lens-creation-grid-container-div">CYL Step: {powers.CYL_Step}</div>
                    <div className="confirm-update-popup-lens-creation-grid-container-div">Axis: {powers.Axis}</div>
                    <div className="confirm-update-popup-lens-creation-grid-container-div">Add Min: {powers.Add_Min}</div>
                    <div className="confirm-update-popup-lens-creation-grid-container-div">Add Max: {powers.Add_Max}</div>
                    <div className="confirm-update-popup-lens-creation-grid-container-div">Add Step: {powers.Add_Step}</div>
                    <div className="confirm-update-popup-lens-creation-grid-container-div">Eye: {powers.Eye}</div>

                </div>

                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "15px"}}>

                    <button onClick={update} style={{cursor:"pointer", color:"white", backgroundColor:"#975cb3"}} className="save-button-main hovered">Update</button>

                </div>

            </div>
        </div>
    );
};

export default ConfirmUpdatePopUpLensCreation;
